import mark from './mark'

const install = function(Vue) {
  Vue.directive('watermark', mark)
}

if (window.Vue) {
  window.mark = mark
  Vue.use(install); // eslint-disable-line
}

mark.install = install
export default mark



// WEBPACK FOOTER //
// ./src/directive/watermark/index.js